import { Sparkles } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { AiChat } from "@/components/ai/AiChat";
import { AiDraftTool } from "@/components/ai/AiDraftTool";

export default function AiAssistant() {
    return (
        <div className="p-6 sm:p-10" data-testid="ai-assistant-page">
            <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-2xl bg-klein text-white flex items-center justify-center shrink-0"><Sparkles className="w-6 h-6" /></div>
                <div>
                    <div className="overline">Powered by Claude</div>
                    <h1 className="mt-1 font-display font-bold text-4xl sm:text-5xl text-ink tracking-tight">AI Assistant</h1>
                    <p className="mt-2 text-sm text-ink/55 max-w-2xl">Ask HR questions or get a first draft of job descriptions, review comments, letters and memos. It can't see anyone's records, so always check drafts before use.</p>
                </div>
            </div>
            <Tabs defaultValue="chat" className="mt-8">
                <TabsList data-testid="ai-tabs">
                    <TabsTrigger value="chat" data-testid="ai-tab-chat">Ask HR</TabsTrigger>
                    <TabsTrigger value="write" data-testid="ai-tab-write">Writing tools</TabsTrigger>
                </TabsList>
                <TabsContent value="chat" className="mt-4"><AiChat /></TabsContent>
                <TabsContent value="write" className="mt-4"><AiDraftTool /></TabsContent>
            </Tabs>
        </div>
    );
}
